import { useState } from 'react';
import { ImageFile } from '../types';

export const useStudioModals = () => {
    // Config & Generic Dialogs
    const [showStudioConfig, setShowStudioConfig] = useState(false);
    const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
    const [showThemeModal, setShowThemeModal] = useState(false);
    const [showApiKeyDialog, setShowApiKeyDialog] = useState(false);

    // Feature Managers
    const [isDogmaManagerOpen, setIsDogmaManagerOpen] = useState(false);
    const [isShotLibraryOpen, setIsShotLibraryOpen] = useState(false);
    const [isProjectManagerOpen, setIsProjectManagerOpen] = useState(false);
    const [isCharacterManagerOpen, setIsCharacterManagerOpen] = useState(false);

    // User & Session
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

    // Découpage Pro
    const [isContactSheetOpen, setIsContactSheetOpen] = useState(false);

    // Nano Banana Pro (Storyboard)
    const [storyboardModalContext, setStoryboardModalContext] = useState<{
        segmentIndex: number;
        baseImage: ImageFile;
        currentPrompt: string;
        mode: 'single-select' | 'ordered-select';
    } | null>(null);

    return {
        // Config
        showStudioConfig,
        setShowStudioConfig,
        isExportDialogOpen,
        setIsExportDialogOpen,
        showThemeModal,
        setShowThemeModal,
        showApiKeyDialog,
        setShowApiKeyDialog,

        // Managers
        isDogmaManagerOpen,
        setIsDogmaManagerOpen,
        isShotLibraryOpen,
        setIsShotLibraryOpen,
        isProjectManagerOpen,
        setIsProjectManagerOpen,
        isCharacterManagerOpen,
        setIsCharacterManagerOpen,

        // User/Session
        isProfileModalOpen,
        setIsProfileModalOpen,
        isHistoryModalOpen,
        setIsHistoryModalOpen,

        // Decoupage
        isContactSheetOpen,
        setIsContactSheetOpen,

        // Nano
        storyboardModalContext,
        setStoryboardModalContext
    };
};
